import { render, staticRenderFns } from "./VerifyForgetPasswordPage.vue?vue&type=template&id=519e7613&scoped=true"
import script from "./VerifyForgetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./VerifyForgetPasswordPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e7613",
  null
  
)

export default component.exports